<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Emitente
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.sefazStatus">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Dados Sefaz
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.manifestoId + ''"
            v-if="rowData.manifestoAqua"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Aquaviário
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t9' + rowData.manifestoId + ''"
            v-if="rowData.manifestoRodo != null"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Rodoviário
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.manifestoId + ''"
            v-if="rowData.manifestoAqua"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Percurso
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-if="rowData.manifestoEvento.length > 0"
            v-bind:href="'#t6' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Eventos
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-if="rowData.manifestoDoc"
            v-bind:href="'#t7' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-if="
              rowData.manifestoSeguro &&
              rowData.manifestoSeguro != null &&
              rowData.manifestoSeguro.length > 0
            "
            v-bind:href="'#t8' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Seguro
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-if="rowData.sefazTentativas > 0"
            v-bind:href="'#t10' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Erros
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-if="
              rowData.manifestoRodo != null &&
              rowData.manifestoRodo.manifestoRodoLacre &&
              rowData.manifestoRodo.manifestoRodoLacre.length > 0
            "
            v-bind:href="'#t11' + rowData.manifestoId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Lacres
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.manifestoId + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Razão Social</th>
                <th style="width: 10%">IE</th>
                <th style="width: 30%">Tipo Emitente</th>
                <th style="width: 5%">Mod Manifesto</th>
                <th style="width: 5%">Forma Emitente</th>
                <th style="width: 20%">Processo Emitente</th>
                <th style="width: 10%">Versão APP</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.razaoSocialEmit }}
                </td>
                <td>
                  {{ rowData.ieEmit }}
                </td>
                <td>
                  {{ rowData.livTipoEmit.descr }}
                </td>
                <td>
                  {{ rowData.modManifesto }}
                </td>
                <td>
                  {{ rowData.livFormaEmi.descr }}
                </td>
                <td>
                  {{ rowData.livProcessoEmi.descr }}
                </td>
                <td>
                  {{ rowData.versaoApp }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Chave</th>
                <th style="width: 10%">UF Carrega</th>
                <th style="width: 10%">UF Descarrega</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.chaveMdfe }}
                </td>
                <td>
                  {{ rowData.ufCarreg }}
                </td>
                <td>
                  {{ rowData.ufDdescarreg }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Observação</th>
                <th style="width: 50%">Observação Fiscal</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.obs }}
                </td>
                <td>
                  {{ rowData.obsCompl }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.manifestoId + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Município</th>
                <th style="width: 10%">UF</th>
                <th style="width: 20%">CEP</th>
                <th style="width: 20%">Endereço</th>
                <th style="width: 10%">Número</th>
                <th style="width: 10%">Complemento</th>
                <th style="width: 10%">Bairro</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.municipioEmitente }}
                </td>
                <td>
                  {{ rowData.ufEmit }}
                </td>
                <td>
                  {{ rowData.cepEmit }}
                </td>
                <td>
                  {{ rowData.enderecoEmit }}
                </td>
                <td>
                  {{ rowData.numEmit }}
                </td>
                <td>
                  {{ rowData.complementoEmit }}
                </td>
                <td>
                  {{ rowData.bairroEmit }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-if="rowData.sefazStatus"
          v-bind:id="'t3' + rowData.manifestoId + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 40%">Status</th>
                <th style="width: 30%">Data/Hora Recebimento</th>
                <th style="width: 40%">Protocolo SEFAZ</th>
                <th style="width: 40%">Recibo</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.sefazStatus }} - {{ rowData.sefazStatusDescr }}
                </td>
                <td>
                  {{ formatDate(rowData.sefazDtHrRecebimento, "DD/MM/YYYY") }}
                </td>
                <td>
                  {{ rowData.sefazProtocolo }}
                </td>
                <td>
                  {{ rowData.numRecibo }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-if="rowData.manifestoAqua"
          v-bind:id="'t4' + rowData.manifestoId + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 15%">CNPJ</th>
                <th style="width: 15%">Tipo Embarcação</th>
                <th style="width: 15%">Embarcação</th>
                <th style="width: 15%">Viagem</th>
                <th style="width: 20%">Porto de Origem</th>
                <th style="width: 10%">Porto de Destino</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.manifestoAqua.cnpj }}
                </td>
                <td>
                  {{ rowData.manifestoAqua.livTipoEmbarcacao.descr }}
                </td>
                <td>
                  {{ rowData.manifestoAqua.cdEmbarcacao }}
                </td>
                <td>
                  {{ rowData.manifestoAqua.numViagem }}
                </td>
                <td>
                  {{ rowData.manifestoAqua.portoOrig }}
                </td>
                <td>
                  {{ rowData.manifestoAqua.portoDes }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-if="rowData.manifestoAqua"
          v-bind:id="'t5' + rowData.manifestoId + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">Ordem</th>
                <th style="width: 30%">UF</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.manifestoPercurso"
              >
                <td>
                  {{ item.ordem }}
                </td>
                <td>
                  {{ item.uf }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t6' + rowData.manifestoId + ''"
          v-if="rowData.manifestoEvento"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">CNPJ Evento</th>
                <th style="width: 20%">Data Evento</th>
                <th style="width: 20%">Município/Uf de Encerramento</th>
                <th style="width: 10%">Tipo Evento</th>
                <th style="width: 40%" colspan="2">Obs</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.manifestoEvento"
              >
                <td>
                  {{ item.cnpjEvento }}
                </td>
                <td>
                  {{ formatDate(item.dtEvento, "DD/MM/YYYY") }}
                </td>
                <td>
                  <span v-if="item.municipio != null">
                    {{ item.municipio }} - {{ item.municipio.uf }}
                  </span>
                </td>
                <td>
                  <span class="label label-warning">{{ item.tpEvento }}</span>
                </td>
                <td colspan="2">
                  {{ item.obs }}
                </td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th style="width: 5%">Evento Sefaz</th>
                <th style="width: 30%">Status Sefaz</th>
                <th style="width: 20%">Hora Evento Sefaz</th>
                <th style="width: 20%">Protocolo Sefaz</th>
                <th style="width: 5%">Orgão Evento Sefaz</th>
                <th style="width: 20%">Versão de Aplicação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.manifestoEvento"
              >
                <td>
                  {{ item.sefazDescrEvento }}
                </td>
                <td>
                  {{ item.sefazDescrStatus }}
                </td>
                <td>
                  {{ formatDate(item.sefazDtHrEvento, "DD/MM/YYYY") }}
                </td>
                <td>
                  {{ item.sefazProtocolo }}
                </td>
                <td>
                  {{ item.sefazOrgaoEvento }}
                </td>
                <td>
                  {{ item.sefazVersaoAplicacao }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t7' + rowData.manifestoId + ''"
          v-if="rowData.manifestoDoc"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Nº Fiscal CTE</th>
                <th style="width: 5%">Série</th>
                <th style="width: 20%">Data Emissão</th>
                <th style="width: 50%">Chave CTE</th>
                <th style="width: 15%">Status CTE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.manifestoDoc"
              >
                <td>
                  {{ item.doc.numFiscal }}
                </td>
                <td>
                  {{ item.doc.serie }}
                </td>
                <td>
                  {{ formatDate(item.doc.dtEmi, "DD/MM/YYYY") }}
                </td>
                <td>
                  {{ item.doc.docCte.chave }}
                </td>
                <td>
                  <span
                    class="label label-warning"
                    v-if="item.doc.docCte.statusSefaz.valor == 1"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="label label-primary"
                    v-if="item.doc.docCte.statusSefaz.valor == 2"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="label label-warning"
                    v-if="item.doc.docCte.statusSefaz.valor == 3"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="label label-success"
                    v-if="item.doc.docCte.statusSefaz.valor == 4"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="label label-danger"
                    v-if="item.doc.docCte.statusSefaz.valor == 5"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="label label-danger"
                    v-if="item.doc.docCte.statusSefaz.valor == 6"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="label label-danger"
                    v-if="item.doc.docCte.statusSefaz.valor == 7"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="label label-info"
                    v-if="item.doc.docCte.statusSefaz.valor == 8"
                    >{{ item.doc.docCte.statusSefaz.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t8' + rowData.manifestoId + ''"
          v-if="rowData.manifestoSeguro != null"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Responsável</th>
                <th style="width: 5%">Seguradora</th>
                <th style="width: 20%">Apolice</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.manifestoSeguro">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.paramTipoRespSeg.descr }}
                </td>
                <td>
                  {{ item.seguradora.nome }}
                </td>
                <td>
                  {{ item.seguradora.apolice }}
                </td>
              </tr>
              <tr v-if="item.manifestoSeguroAverbacao">
                <th colspan="3">Nº Averbação</th>
              </tr>
              <tr
                v-if="item.manifestoSeguroAverbacao"
                v-for="item2 in item.manifestoSeguroAverbacao"
              >
                <td colspan="3">{{ item2.numAverbacao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t9' + rowData.manifestoId + ''"
          v-if="rowData.manifestoRodo != null"
        >
          <b-tabs style="width: 100%">
            <b-tab title="Detalhes" active>
              <b-form-text><strong>RNTRC</strong></b-form-text>
              {{ rowData.manifestoRodo.rntrc }}
            </b-tab>

            <b-tab
              title="Veiculos"
              v-if="
                rowData.manifestoRodo != null &&
                rowData.manifestoRodo.manifestoRodoTracao != null
              "
            >
              <b-container fluid class="p-a-0">
                <b-row no-gutters>
                  <b-form-text><strong>Tração</strong></b-form-text>
                  <table class="table-striped">
                    <thead>
                      <tr>
                        <th style="width: 10%">Código</th>
                        <th style="width: 15%">Placa</th>
                        <th style="width: 10%">Tara</th>
                        <th style="width: 15%">Renavam</th>
                        <th style="width: 15%">Tipo Rodado</th>
                        <th style="width: 10%">UF Veículo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span
                            v-if="
                              rowData.manifestoRodo != null &&
                              rowData.manifestoRodo.manifestoRodoTracao != null
                            "
                            >{{
                              rowData.manifestoRodo.manifestoRodoTracao
                                .cdVeiculo
                            }}</span
                          >
                        </td>
                        <td>
                          <span
                            v-if="
                              rowData.manifestoRodo != null &&
                              rowData.manifestoRodo.manifestoRodoTracao != null
                            "
                            >{{
                              rowData.manifestoRodo.manifestoRodoTracao.placa
                            }}</span
                          >
                        </td>
                        <td>
                          <span
                            v-if="
                              rowData.manifestoRodo != null &&
                              rowData.manifestoRodo.manifestoRodoTracao != null
                            "
                            >{{
                              rowData.manifestoRodo.manifestoRodoTracao.tara
                            }}</span
                          >
                        </td>
                        <td>
                          <span
                            v-if="
                              rowData.manifestoRodo != null &&
                              rowData.manifestoRodo.manifestoRodoTracao != null
                            "
                            >{{
                              rowData.manifestoRodo.manifestoRodoTracao.renavam
                            }}</span
                          >
                        </td>
                        <td>
                          <span
                            v-if="
                              rowData.manifestoRodo != null &&
                              rowData.manifestoRodo.manifestoRodoTracao != null
                            "
                            >{{
                              rowData.manifestoRodo.manifestoRodoTracao
                                .paramTipoRodado.descr
                            }}</span
                          >
                        </td>
                        <td>
                          <span
                            v-if="
                              rowData.manifestoRodo != null &&
                              rowData.manifestoRodo.manifestoRodoTracao != null
                            "
                            >{{
                              rowData.manifestoRodo.manifestoRodoTracao
                                .ufVeiculo
                            }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <b-form-text><strong>Reboques</strong></b-form-text>
                  <table class="table-striped">
                    <thead>
                      <tr>
                        <th style="width: 10%">Código</th>
                        <th style="width: 15%">Placa</th>
                        <th style="width: 10%">Tara</th>
                        <th style="width: 15%">Renavam</th>
                        <th style="width: 15%">Tipo Rodado</th>
                        <th style="width: 10%">UF Veículo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in rowData.manifestoRodo
                          .manifestoRodoReboque"
                      >
                        <td>
                          <span v-if="item.cdVeiculo">{{
                            item.cdVeiculo
                          }}</span>
                        </td>
                        <td>
                          <span v-if="item.placa">{{ item.placa }}</span>
                        </td>
                        <td>
                          <span v-if="item.tara">{{ item.tara }}</span>
                        </td>
                        <td>
                          <span v-if="item.renavam">{{ item.renavam }}</span>
                        </td>
                        <td>
                          <span v-if="item.paramTipoRodado.descr">{{
                            item.paramTipoRodado.descr
                          }}</span>
                        </td>
                        <td>
                          <span v-if="item.ufVeiculo">{{
                            item.ufVeiculo
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-row>
              </b-container>
            </b-tab>

            <b-tab
              title="CIOT"
              v-if="
                rowData.manifestoRodo.manifestoRodoCiot &&
                rowData.manifestoRodo.manifestoRodoCiot != null &&
                rowData.manifestoRodo.manifestoRodoCiot.length > 0
              "
            >
              <b-container fluid class="p-a-0">
                <b-row no-gutters>
                  <table class="table-striped">
                    <thead>
                      <tr>
                        <th style="width: 30%">CIOT</th>
                        <th style="width: 30%">CNPJ</th>
                        <th style="width: 30%">CPF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in rowData.manifestoRodo
                          .manifestoRodoCiot"
                      >
                        <td>
                          <span v-if="row.ciot">{{ row.ciot }}</span>
                        </td>
                        <td>
                          <span v-if="row.cnpj">{{ row.cnpj }}</span>
                        </td>
                        <td>
                          <span v-if="row.cpf">{{ row.cpf }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-row>
              </b-container>
            </b-tab>

            <b-tab
              title="Contratante"
              v-if="
                rowData.manifestoRodo.manifestoRodoContratante &&
                rowData.manifestoRodo.manifestoRodoContratante != null &&
                rowData.manifestoRodo.manifestoRodoContratante.length > 0
              "
            >
              <b-container fluid class="p-a-0">
                <b-row no-gutters>
                  <table class="table-striped">
                    <thead>
                      <tr>
                        <th style="width: 50%">CNPJ</th>
                        <th style="width: 50%">CPF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in rowData.manifestoRodo
                          .manifestoRodoContratante"
                      >
                        <td>
                          <span v-if="row.cnpj">{{ row.cnpj }}</span>
                        </td>
                        <td>
                          <span v-if="row.cpf">{{ row.cpf }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-row>
              </b-container>
            </b-tab>

            <b-tab
              title="Vale Pedágio"
              v-if="
                rowData.manifestoRodo.manifestoRodoVale &&
                rowData.manifestoRodo.manifestoRodoVale != null &&
                rowData.manifestoRodo.manifestoRodoVale.length > 0
              "
            >
              <b-container fluid class="p-a-0">
                <b-row no-gutters>
                  <table class="table-striped">
                    <thead>
                      <tr>
                        <th style="width: 20%">CNPJ Fornecedor</th>
                        <th style="width: 20%">CNPJ Pagador</th>
                        <th style="width: 20%">CPF Pagador</th>
                        <th style="width: 15%">N° da compra</th>
                        <th style="width: 15%">Valor do vale</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in rowData.manifestoRodo
                          .manifestoRodoVale"
                      >
                        <td>
                          <span v-if="row.cnpjFornecedor">{{
                            row.cnpjFornecedor
                          }}</span>
                        </td>
                        <td>
                          <span v-if="row.cnpjPagador">{{
                            row.cnpjPagador
                          }}</span>
                        </td>
                        <td>
                          <span v-if="row.cpfPagador">{{
                            row.cpfPagador
                          }}</span>
                        </td>
                        <td>
                          <span v-if="row.numCompra">{{ row.numCompra }}</span>
                        </td>
                        <td>
                          <span v-if="row.vlrVale">{{ row.vlrVale }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-row>
              </b-container>
            </b-tab>

            <b-tab
              title="Lacres"
              v-if="
                rowData.manifestoRodo.manifestoRodoLacre &&
                rowData.manifestoRodo.manifestoRodoLacre != null &&
                rowData.manifestoRodo.manifestoRodoLacre.length > 0
              "
            >
              <b-container fluid class="p-a-0">
                <b-row no-gutters>
                  <table class="table-striped">
                    <thead>
                      <tr>
                        <th>Número Lacre</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in rowData.manifestoRodo
                          .manifestoRodoLacre"
                      >
                        <td>
                          <span v-if="row.numLacre">{{ row.numLacre }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-row>
              </b-container>
            </b-tab>
          </b-tabs>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t10' + rowData.manifestoId + ''"
          v-if="rowData.sefazTentativas > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 60%">Erro Wsdl</th>
                <th style="width: 20%">Total tentativas</th>
                <th style="width: 20%">Data última tentativa</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.sefazValidadorWsdl }}
                </td>
                <td>
                  {{ rowData.sefazTentativas }}
                </td>
                <td>
                  {{ formatDate(rowData.sefazDtUltTentativa) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-if="
            rowData.manifestoRodo != null &&
            rowData.manifestoRodo.manifestoRodoLacre &&
            rowData.manifestoRodo.manifestoRodoLacre.length > 0
          "
          v-bind:id="'t11' + rowData.manifestoId + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">Numero do Lacre</th>
                <th style="width: 20%">Status</th>
                <th style="width: 20%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.manifestoRodo.manifestoRodoLacre"
              >
                <td>
                  {{ item.numLacre }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    v-if="item.status.valor == 2"
                    @click="onActivateDesactivate(1, item, true)"
                    v-b-tooltip
                    title="Ativar"
                    ><i class="fa fa-thumbs-o-up"></i
                  ></a>
                  <a
                    v-if="item.status.valor == 1"
                    @click="onActivateDesactivate(2, item, true)"
                    v-b-tooltip
                    title="Inativar"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                  <a
                    @click="onEditLacre(item)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--.tab-content-->
    </div>
    <LacreModalForm ref="lacremodalform"> </LacreModalForm>
  </div>
</template>

<script>
import LacreModalForm from "./LacreModalForm.vue";
import accounting from "accounting";
import moment from "moment";
export default {
  components: {
    LacreModalForm,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  methods: {
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({
          id: data.manrodlacId,
          status: action,
        });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }
      this.$refs.lacremodalform.onActivateDesactivate(this.helpForm);
    },
    onEditLacre(data) {
      this.$refs.lacremodalform.onEdit(data);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
  },
};
</script>
